import React from 'react';
import { Translate } from '@pegasus/translation';
import { AccountS as AccountIcon, HelpS as HelpIcon, InformationS as InformationIcon, SignOutS as SignOutIcon, } from '@lux/icons';
import { Text, Preset } from '@lux/text';
import { logout } from '../../../../lib/logout';
import { isMobile } from '../../../../lib/screenSize';
import { SubMenuName } from '../MobileSubMenu/types';
import { Wrapper, ItemWrapper, ItemLink, Icon } from './styles';
export const items = [
    {
        link: '/myaccount',
        translationKey: 'your-account',
        icon: AccountIcon,
        submenu: SubMenuName.myaccount,
    },
    {
        link: '/help',
        translationKey: 'help',
        icon: HelpIcon,
        submenu: SubMenuName.none,
    },
    {
        link: '/aboutus',
        translationKey: 'about-us',
        icon: InformationIcon,
        submenu: SubMenuName.about,
        hiddenOnDesktop: true,
    },
];
export const MenuItems = ({ setSubMenu, closeNavigation, csrfToken }) => (React.createElement(Wrapper, null,
    items.map(({ link, translationKey, icon: ItemIcon, submenu, hiddenOnMobile, hiddenOnDesktop, }) => {
        return (React.createElement(ItemWrapper, { key: translationKey, hiddenOnMobile: hiddenOnMobile, hiddenOnDesktop: hiddenOnDesktop !== undefined && hiddenOnDesktop === true },
            React.createElement(ItemLink, { href: link, onClick: e => {
                    if (submenu !== SubMenuName.none && isMobile()) {
                        e.preventDefault();
                        setSubMenu(submenu);
                    }
                    else {
                        closeNavigation();
                    }
                } },
                React.createElement(Icon, null,
                    React.createElement(ItemIcon, { color: "currentColor", "aria-labelledby": `myaccount-menu-link-${translationKey}` })),
                React.createElement(Text, { id: `myaccount-menu-link-${translationKey}`, preset: Preset.S, color: "inherit" },
                    React.createElement(Translate, { message: translationKey })))));
    }),
    React.createElement(ItemWrapper, null,
        React.createElement(ItemLink, { href: "/logout", onClick: e => {
                e.preventDefault();
                logout(csrfToken);
            } },
            React.createElement(Icon, null,
                React.createElement(SignOutIcon, { color: "currentColor", "aria-labelledby": "myaccount-menu-link-logout" })),
            React.createElement(Text, { id: "myaccount-menu-link-logout", preset: Preset.S, color: "inherit" },
                React.createElement(Translate, { message: "logout" }))))));
//# sourceMappingURL=index.js.map